import { gsap } from 'gsap'
import { deepMerge, getCubicCurve } from 'js/utils/Utils'

const defaults = {
  instanceName: 'subPageHomeFVAnimation',
  $names: {
    titleMaskIn: '[data-fv-anim="subpage-home-title"] .mask_in',
    breadcrumbTextMaskIn: '[data-fv-anim="sup-page-breadcrumb-txt"] .mask_in',
    lineMaskIn: '[data-fv-anim="subpage-home-line"] .mask_in',
    line2MaskIn: '[data-fv-anim="subpage-home-line2"] .mask_in',
    navMaskIn: '[data-fv-anim="subpage-home-nav"] .mask_in',
  },
}

export default class SubPageHomeFVAnimation {
  $contentRoot = document
  $titleMaskIn = null
  $breadcrumbTextMaskIns = null
  $lineMaskIns = null
  $line2MaskIns = null
  $navMaskIns = []
  constructor(options = {}) {
    deepMerge(this, defaults, options)
  }

  init() {
    this._set$()
    this.initStyle()
  }

  destroy() {}

  _set$() {
    this.$titleMaskIn = this.$contentRoot.querySelector(this.$names.titleMaskIn)
    this.$breadcrumbTextMaskIns = this.$contentRoot.querySelectorAll(this.$names.breadcrumbTextMaskIn)
    this.$lineMaskIns = this.$contentRoot.querySelectorAll(this.$names.lineMaskIn)
    this.$line2MaskIns = this.$contentRoot.querySelectorAll(this.$names.line2MaskIn)

    this.$navMaskIns = this.$contentRoot.querySelectorAll(this.$names.navMaskIn)
  }

  initStyle() {
    if (this.$titleMaskIn) {
      gsap.set(this.$titleMaskIn, {
        yPercent: 100,
        rotate: 0.001,
        opacity: 0,
      })
    }

    if (this.$breadcrumbTextMaskIns) {
      this.$breadcrumbTextMaskIns.forEach(($el) => {
        gsap.set($el, {
          yPercent: 100,
          rotate: 0.001,
          opacity: 0,
        })
      })
    }

    if (this.$lineMaskIns && this.$lineMaskIns.length) {
      gsap.set(this.$lineMaskIns, {
        xPercent: -100,
        rotate: 0.001,
        force3D: false,
        opacity: 0,
      })
    }
    if (this.$line2MaskIns && this.$line2MaskIns.length) {
      gsap.set(this.$line2MaskIns, {
        xPercent: -100,
        rotate: 0.001,
        force3D: false,
        opacity: 0,
      })
    }

    if (this.$navMaskIns) {
      this.$navMaskIns.forEach(($el) => {
        gsap.set($el, {
          yPercent: 100,
          rotate: 0.001,
          opacity: 0,
        })
      })
    }
  }

  run() {
    if (this.$titleMaskIn) {
      requestAnimationFrame(() => {
        gsap.to(this.$titleMaskIn, {
          opacity: 1,
          duration: 0,
          delay: 0.15,
        })
        gsap.to(this.$titleMaskIn, {
          yPercent: 0,
          rotate: 0.001,
          force3D: false,
          duration: 1.25,
          delay: 0.15,
          ease: 'expo.out',
        })
      })
    }

    if (this.$breadcrumbTextMaskIns) {
      this.$breadcrumbTextMaskIns.forEach(($el, i) => {
        requestAnimationFrame(() => {
          gsap.to($el, {
            opacity: 1,
            duration: 0,
            delay: 0.15 + (i + 1) * 0.01,
          })
          gsap.to($el, {
            yPercent: 0,
            rotate: 0.001,
            force3D: false,
            duration: 1.25,
            delay: 0.15 + (i + 1) * 0.01,
            ease: 'expo.out',
          })
        })
      })
    }

    if (this.$lineMaskIns && this.$lineMaskIns.length) {
      requestAnimationFrame(() => {
        gsap.to(this.$lineMaskIns, {
          opacity: 1,
          duration: 0,
          delay: 0.15 + 0.1,
        })
        gsap.to(this.$lineMaskIns, {
          xPercent: 0,
          rotate: 0.001,
          force3D: false,
          duration: 1.6,
          // delay: 0.15 + 0.1,
          ease: getCubicCurve(0.6, 0.0, 0.15, 1),
          // ease: 'cubic.inOut',
          stagger: 0.04,
        })
      })
    }

    if (this.$line2MaskIns && this.$line2MaskIns.length) {
      requestAnimationFrame(() => {
        gsap.to(this.$line2MaskIns, {
          opacity: 1,
          duration: 0,
          delay: 0.15 + 0.1 + 0.2,
        })
        gsap.to(this.$line2MaskIns, {
          xPercent: 0,
          rotate: 0.001,
          force3D: false,
          duration: 0.8,
          delay: 0.15 + 0.1 + 0.2,
          ease: getCubicCurve(0.6, 0.0, 0.15, 1),
          // ease: 'cubic.inOut',
          stagger: 0.04,
        })
      })
    }

    if (this.$navMaskIns) {
      this.$navMaskIns.forEach(($el, i) => {
        requestAnimationFrame(() => {
          gsap.to($el, {
            opacity: 1,
            duration: 0,
            delay: 0.15 + 0.2 + (i + 1) * 0.01,
          })
          gsap.to($el, {
            yPercent: 0,
            rotate: 0.001,
            force3D: false,
            duration: 1.25,
            delay: 0.15 + 0.2 + (i + 1) * 0.01,
            ease: 'expo.out',
          })
        })
      })
    }
  }
}